import React from 'react';
import monthly_gifts_illustration from '../../images/illustrations/recurring_gift_green_bg_100.png';
import gift_matching_2x from '../../images/illustrations/gift_matching_2x.png';
import gg_logo from '../../images/logos/logo.png';
import './Gg_plus_shared.css';

/**
 * Benefit cards shown on the GG+ membership page (all states).
 * Layout per mockup: title → illustration/logo → body copy.
 */
function Gg_plus_feature_cards({ sectionTitle = 'Unlock Tools With GG+' }) {
  return (
    <div>
      <h2 className="membership_feature_section_title">{sectionTitle}</h2>

      <div className="membership_feature_card">
        <h3 className="membership_feature_card_title">Monthly Gifts</h3>
        <img
          src={monthly_gifts_illustration}
          alt=""
          className="membership_feature_card_img"
        />
        <p className="membership_feature_card_body">
          Perfect for the closest circle who want to contribute regularly over time.
          A simple way for your closest circle to keep showing up for the future.
        </p>
      </div>

      <div className="membership_feature_card">
        <h3 className="membership_feature_card_title">Gift Matching</h3>
        <img
          src={gift_matching_2x}
          alt=""
          className="membership_feature_card_img"
        />
        <p className="membership_feature_card_body">
          Multiply the impact of every gift. Matching adds extra funds and inspires
          more people to give - knowing their gift has greater impact.
        </p>
      </div>

      <div className="membership_feature_card">
        <h3 className="membership_feature_card_title">Included with Every GG Account</h3>
        <img src={gg_logo} alt="Greatest Gift" className="membership_gg_logo" />
        <p className="membership_feature_card_body">
          Create gifting pages, receive gifts, and share your child&apos;s goals.
          Discover great ways to save and invest.
        </p>
      </div>
    </div>
  );
}

export default Gg_plus_feature_cards;
